import React from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';

import { Card } from 'commons-ui';
import usePermission from '../../permission/usePermission';
import { SETTINGS_V2_RESOURCES, PAGE_NAMES } from '../../settingsV2Constant';
import './style.css';

import { URL, LABEL, IMAGE_SOURCE } from './helper';

const useSettingsHome = () => {
	const { hasPermission } = usePermission();

	const isEnabled = (configResourceName: string) => {
		return hasPermission({
			configPageName: PAGE_NAMES.settingsV2,
			configResourceName
		});
	};

	return { isEnabled };
};

const SettingsHome: React.FC<{}> = () => {
	const history = useHistory();
	const { isEnabled } = useSettingsHome();

	return (
		<div className='home-container'>
			{_map(_keys(SETTINGS_V2_RESOURCES), (resourceName) => {
				return isEnabled(resourceName) ? (
					<div
						key={resourceName}
						className='home-item'
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[resourceName]);
						}}>
						<Card label={LABEL[resourceName]} img={IMAGE_SOURCE[resourceName]} />
					</div>
				) : null;
			})}
		</div>
	);
};

export default SettingsHome;
